import {Component, Input} from '@angular/core';
import {ReflexiveField} from '../../reflexive-model/reflexive-field';
import {ClipboardService} from 'ngx-clipboard';

@Component({
  selector: 'app-gelios-template-data',
  templateUrl: './gelios-template-data.component.html',
  styleUrls: ['./gelios-template-data.component.scss']
})
export class GeliosTemplateDataComponent {
  @Input() reflexiveField: ReflexiveField;
  copiedId: string | null = null;
  private timeoutId: any;

  constructor(
    private clipboard: ClipboardService,
  ) {
  }

  copyFromContent(patternName: string) {
    this.clipboard.copyFromContent(this.getPattern(patternName));
    this.copiedId = patternName;

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.copiedId = null;
      this.timeoutId = null;
    }, 1000);
  }

  getPattern(patternName: string): string {
    return `{{${patternName}}}`;
  }

  getIcon(itemId: string): string {
    return this.copiedId === itemId ? 'ic_check' : 'ic-copy_sm';
  }
}
